<template>
  <div>
    <h1>Nova oportunidade</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    ...mapActions("oportunidades", ["ActionNewOportunidade"]),
    loadData(id) {
      this.$router.push({ name: "oportunidades_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewOportunidade();
  },
};
</script>

<style></style>
